import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ENV, IEnv } from '@pf/shared/config';
import { CustomHttpParamEncoder, removeEmptyFields } from '../helpers';
import { IPaginationParams } from '@stride-ui/components';
import { IQueryParams } from '@move-frontend/portal-toolkit';

@Injectable({ providedIn: 'root' })
export class Api {
  private readonly env: IEnv = inject(ENV);
  private readonly httpClient: HttpClient = inject(HttpClient);

  public get$<T>(resource: string, params?: IQueryParams | IPaginationParams): Observable<T> {
    const endpoint: string = this.getEndpoint(resource);

    return this.httpClient.get<T>(endpoint, {
      params: new HttpParams({ fromObject: removeEmptyFields(params), encoder: new CustomHttpParamEncoder() }),
    });
  }

  public post$<Response, Request>(resource: string, request: Request): Observable<Response> {
    const endpoint: string = this.getEndpoint(resource);

    return this.httpClient.post<Response>(endpoint, request);
  }

  public put$<Response, Request>(resource: string, request: Request): Observable<Response> {
    const endpoint: string = this.getEndpoint(resource);

    return this.httpClient.put<Response>(endpoint, request);
  }

  public getFile$(resource: string, params?: IQueryParams): Observable<Blob> {
    const endpoint: string = this.getEndpoint(resource);

    return this.httpClient.get(endpoint, {
      params: new HttpParams({ fromObject: removeEmptyFields(params), encoder: new CustomHttpParamEncoder() }),
      responseType: 'blob',
    });
  }

  private getEndpoint(resource: string): string {
    return `${this.env.apiUrl}/${resource}`;
  }
}
